import { useMemo } from "react";

const ImageBox = {
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  paddingTop: "2rem",
};

const image = {
  margin: "auto",
};

function Image(props) {
  const url = useMemo(() => {
    return props.link || props.location?.useProps?.fileUrl || props.fileUrl;
  }, [props]);
  return (
    <div style={ImageBox}>
      {/* <h4>{props.location.useProps.moduleName}</h4> */}
      <img style={image} src={url} alt={url} />
    </div>
  );
}

export default Image;
